import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useStore } from "../../../stores/store";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useSubmitData } from "../../../hooks/useSubmitData";
import { useSetMenu } from "../../../hooks/useSetMenu";
import FormLayout from '../../Generic/FormLayout';
import FormInput from '../../Generic/FormInput';
import * as yup from "yup";
import FormSelect from '../../Generic/FormSelect';
import FormFile from "../../Generic/FormFile";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const Add = () => {

    const { mainStore } = useStore();
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const axiosPrivate = useAxiosPrivate();
    const [logo, setLogo] = useState();
    const [logoName, setLogoName] = useState();

    useSetMenu(mainStore.ToolPassportMenuType, mainStore.ToolPassportMenuNo);
    const onError = (errors, e) =>
        enqueueSnackbar(t("onErrorSubmit"), { variant: "error" });

    const schema = yup.object({
        name: yup
            .string()
            .required(t('requiredField'))
            .max(250, t('maxLength', { max: 250 })),
        typeOfToolId: yup.string().required(t("selectRequired")),
        panelId: yup.string().required(t("selectRequired")),
        categoryId: yup.string().required(t("selectRequired")),
        subcategoryId: yup.string().required(t("selectRequired")),
        logoName: yup
            .string()
            .max(250, t('maxLength', { max: 250 })),
        logoPath: yup
            .string()
            .max(450, t('maxLength', { max: 450 })),
        function: yup.string().required(t('requiredField')),
        abstractionLevel: yup.string().required(t('requiredField')),
        iOConnection: yup.string().required(t('requiredField')),
        verificationTool: yup.string().required(t('requiredField')),
        applicationAreaOrEquivalenceCoverage: yup.string().required(t('requiredField')),
        qualitativeFeature: yup.string().required(t('requiredField')),
        quantitativeFeature: yup.string().required(t('requiredField')),
        // toolURL: yup.string().required(t('requiredField')),
    });

    const {
        register,
        handleSubmit,
        setValue,
        control,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });

    const sendData = useSubmitData(axiosPrivate, "/ToolPassports", "/ToolPassport/List");
    const onSubmit = (data) => {
        const formData = new FormData();
        Object.keys(data).forEach((fieldName) => {
            if (data[fieldName] != null) {
                formData.append(fieldName, data[fieldName]);
            }
        });
        formData.append("LogoName", logoName);
        formData.append("FormFile", logo);
        sendData(formData);
    }

    const onCancel = () => navigate(-1);

    useEffect(() => {
        loadData();
        // eslint-disable-next-line
    }, [t]);

    //#region 
    const [typeOfTools, setTypeOfTools] = useState([]);
    const [panels, setPanels] = useState([]);
    const [categories, setCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);

    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedSubcategory, setSelectedSubcategory] = useState(null);

    async function loadData() {
        try {
            const typeOfToolsResponse = await axiosPrivate.get("/TypeOfTools/SelectOptions");
            const panelsResponse = await axiosPrivate.get("/Panels/SelectOptions");
            setTypeOfTools(typeOfToolsResponse.data);
            setPanels(panelsResponse.data);


        } catch (err) {
            enqueueSnackbar(t("loadDataError"), { variant: "error" });
        }
    }
    const handleTypeOfToolChange = selectedOption => {
        setValue("typeOfToolId", selectedOption.value, { shouldValidate: true });
    };
    const handleSubcategoryChange = selectedOption => {
        setValue("subcategoryId", selectedOption.value, { shouldValidate: true });
        setSelectedSubcategory(selectedOption);
    };

    const handleCategoryChange = async (selectedOption) => {
        setValue("categoryId", selectedOption.value, { shouldValidate: true });
        setSelectedCategory(selectedOption);
        try {
            const response = await axiosPrivate.get(`/Subcategories/SelectOptionsByCategory/${selectedOption.value}`);
            if (typeof response.data === "string" && response.data === "No records") {
                setSubcategories([]);
            } else {
                setSubcategories(response.data);
            }
            setSelectedSubcategory(null);
            setValue("subcategoryId", null, { shouldValidate: true });
        } catch (error) {
            enqueueSnackbar(t("errorLoadingSubcategories"), { variant: "error" });
        }
    };

    const handlePanelChange = async (selectedOption) => {
        setValue("panelId", selectedOption.value, { shouldValidate: true });
        try {
            const response = await axiosPrivate.get(`/Categories/SelectOptionsByPanel/${selectedOption.value}`);
            if (typeof response.data === "string" && response.data === "No records") {
                setCategories([]);

            } else {
                setCategories(response.data);
            }
            setSelectedCategory(null);
            setSubcategories([]);
            setSelectedSubcategory(null);
            setValue("categoryId", null, { shouldValidate: true });
            setValue("subcategoryId", null, { shouldValidate: true });
        } catch (error) {
            enqueueSnackbar(t("errorLoadingCategories"), { variant: "error" });
        }
    };
    //#endregion


    const saveFile = (e) => {
        if (e.target.files[0]) {
            setLogo(e.target.files[0]);
            setLogoName(e.target.files[0].name);
            setValue("logoName", e.target.files[0].name);
        }
    };

    return (
        <FormLayout title={t("toolPassportCreateTitle")} onSubmit={handleSubmit(onSubmit, onError)} onCancel={onCancel}>
            <FormFile label={t("uploadLogo")} colSize={12} name="logoName" register={register} errors={errors} required={false} onChange={(e) => saveFile(e)} type="file" accept="image/*" />
            <FormInput label="toolPassportName" name="name" register={register} errors={errors} colSize={6} />
            <FormSelect label="typeOfTool" name="typeOfToolId" register={register} errors={errors} colSize={6} options={typeOfTools} onChange={handleTypeOfToolChange} />
            <FormInput label="toolPassportToolURL" name="toolURL" register={register} errors={errors} colSize={12} type="url" required={false}/>
            <FormSelect label="panel" name="panelId" register={register} errors={errors} colSize={4} options={panels} onChange={handlePanelChange} />
            <FormSelect label="category" name="categoryId" value={selectedCategory} register={register} errors={errors} colSize={4} options={categories} onChange={handleCategoryChange} />
            <FormSelect label="subcategory" name="subcategoryId" value={selectedSubcategory} register={register} errors={errors} colSize={4} options={subcategories} onChange={handleSubcategoryChange} />
            <div className="form-group mt-2">
                <label className="labelDescription">
                    <span className="labelText">
                        {t("toolPassportFunctions")}
                    </span>
                    <span className="labelStar text-danger fw-bold">*</span>
                </label>
                <Controller
                    name="function"
                    control={control}
                    defaultValue=""
                    render={({ field: { onChange, value } }) => (
                        <ReactQuill
                            theme="snow"
                            value={value}
                            onChange={onChange}

                        />
                    )}
                />
                {errors.function && (
                    <div className="error-message text-danger">
                        {errors.function.message}
                    </div>
                )}
            </div>
            <div className="form-group mt-2">
                <label className="labelDescription">
                    <span className="labelText">
                        {t("toolPassportAbstractionLevel")}
                    </span>
                    <span className="labelStar text-danger fw-bold">*</span>
                </label>
                <Controller
                    name="abstractionLevel"
                    control={control}
                    defaultValue=""
                    render={({ field: { onChange, value } }) => (
                        <ReactQuill
                            theme="snow"
                            value={value}
                            onChange={onChange}

                        />
                    )}
                />
                {errors.abstractionLevel && (
                    <div className="error-message text-danger">
                        {errors.abstractionLevel.message}
                    </div>
                )}
            </div>
            <div className="form-group mt-2">
                <label className="labelDescription">
                    <span className="labelText">
                        {t("toolPassportIOConnection")}
                    </span>
                    <span className="labelStar text-danger fw-bold">*</span>
                </label>
                <Controller
                    name="iOConnection"
                    control={control}
                    defaultValue=""
                    render={({ field: { onChange, value } }) => (
                        <ReactQuill
                            theme="snow"
                            value={value}
                            onChange={onChange}

                        />
                    )}
                />
                {errors.iOConnection && (
                    <div className="error-message text-danger">
                        {errors.iOConnection.message}
                    </div>
                )}
            </div>
            <div className="form-group mt-2">
                <label className="labelDescription">
                    <span className="labelText">
                        {t("toolPassportVerificationTool")}
                    </span>
                    <span className="labelStar text-danger fw-bold">*</span>
                </label>
                <Controller
                    name="verificationTool"
                    control={control}
                    defaultValue=""
                    render={({ field: { onChange, value } }) => (
                        <ReactQuill
                            theme="snow"
                            value={value}
                            onChange={onChange}

                        />
                    )}
                />
                {errors.verificationTool && (
                    <div className="error-message text-danger">
                        {errors.verificationTool.message}
                    </div>
                )}
            </div>
            <div className="form-group mt-2">
                <label className="labelDescription">
                    <span className="labelText">
                        {t("toolPassportApplicationAreaOrEquivalenceCoverage")}
                    </span>
                    <span className="labelStar text-danger fw-bold">*</span>
                </label>
                <Controller
                    name="applicationAreaOrEquivalenceCoverage"
                    control={control}
                    defaultValue=""
                    render={({ field: { onChange, value } }) => (
                        <ReactQuill
                            theme="snow"
                            value={value}
                            onChange={onChange}

                        />
                    )}
                />
                {errors.applicationAreaOrEquivalenceCoverage && (
                    <div className="error-message text-danger">
                        {errors.applicationAreaOrEquivalenceCoverage.message}
                    </div>
                )}
            </div>
            <div className="form-group mt-2">
                <label className="labelDescription">
                    <span className="labelText">
                        {t("toolPassportQualitativeFeature")}
                    </span>
                    <span className="labelStar text-danger fw-bold">*</span>
                </label>
                <Controller
                    name="qualitativeFeature"
                    control={control}
                    defaultValue=""
                    render={({ field: { onChange, value } }) => (
                        <ReactQuill
                            theme="snow"
                            value={value}
                            onChange={onChange}

                        />
                    )}
                />
                {errors.qualitativeFeature && (
                    <div className="error-message text-danger">
                        {errors.qualitativeFeature.message}
                    </div>
                )}
            </div>
            <div className="form-group mt-2">
                <label className="labelDescription">
                    <span className="labelText">
                        {t("toolPassportQuantitativeFeature")}
                    </span>
                    <span className="labelStar text-danger fw-bold">*</span>
                </label>
                <Controller
                    name="quantitativeFeature"
                    control={control}
                    defaultValue=""
                    render={({ field: { onChange, value } }) => (
                        <ReactQuill
                            theme="snow"
                            value={value}
                            onChange={onChange}

                        />

                    )}
                />
                {errors.quantitativeFeature && (
                    <div className="error-message text-danger">
                        {errors.quantitativeFeature.message}
                    </div>
                )}
            </div>

        </FormLayout>
    );
};

export default Add;